import { useSelector } from 'react-redux';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { getStepConfig } from '../views/getStepConfig';
import { WaveType } from '../wave/Wave';
import { useCurrentStep } from './useCurrentStep';
export const useIsWideStep = () => {
  const activeError = useSelector(getActiveError);
  const activeLoading = useSelector(getActiveLoading);
  const postAccountCreation = useSelector(getPostAccountCreationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const stepConfig = getStepConfig(currentStep);
  const isWideStep = stepConfig && stepConfig.isWideStep;

  if (activeError) {
    return {
      isWideStep: true,
      waveType: WaveType.Error
    };
  }

  if (activeLoading) {
    return {
      isWideStep: true
    };
  }

  if (postAccountCreation.includes(currentStep)) {
    return {
      isWideStep: false,
      waveType: WaveType.PostAccountCreation
    };
  }

  return Object.assign({
    isWideStep
  }, isWideStep && {
    waveType: WaveType.Step
  });
};